import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=65445dc2"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports